module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-06 (1).06a17c6a.svg";